module.exports = __webpack_public_path__ + "img/page2.94d46861.png";